import React from 'react'

const Tags = () => {
  return (
    <>
      {(!process.env.REACT_APP_ENV || process.env.REACT_APP_ENV === 'development' || process.env.REACT_APP_ENV ==='staging') &&
      <div className='d-none d-sm-block' style={{
        position: 'fixed',
        zIndex: 9999,
        background: (process.env.REACT_APP_ENV ==='staging' && 'blue')|| (process.env.REACT_APP_ENV === 'development'&& 'red'),
        color: 'white',
        padding: '6px 108px',
        transform: "rotate(-45deg)",
        top: '20px',
        left: (process.env.REACT_APP_ENV === 'development'&& '-112px')|| (process.env.REACT_APP_ENV === 'staging'&& '-100px') ,
      }}>
        {(process.env.REACT_APP_ENV === 'development'&& 'Development')|| (process.env.REACT_APP_ENV === 'staging'&& 'Staging')}  
      </div>
      }
    </>
  )
}

export default Tags